const hex_regex = /^[a-f0-9]{6}$/i
const log = require('log').create('luminance')

module.exports = function getLuminance(color_hex) {
    let hex = color_hex
    if (typeof hex !== 'string') {
        log.error('error getting luminance for:', hex)
        return 'dark'
    }
    if (hex.length === 3) hex = hex.split('').map(n => `${n}${n}`).join('')
    if (! hex_regex.test(hex)) {
        log.error('error getting luminance for:', hex)
        return 'dark'
    }
    // takes a hex, decides whether it's light or dark based on our threshold

    // possible values: 0-255.
    // higher is lighter.
    const threshold = 200

    // hex to rbg
    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)

    // http://alienryderflex.com/hsp.html
    const hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b)
    )

    if (hsp > threshold) return 'light'

    return 'dark'
}
